import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import CdsHeaderNavLink from 'common/components/cds-header/CdsHeaderNavLink';
import { useEffect } from 'react';
import { Badge, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CdsHeader from '../common/components/cds-header/CdsHeader';
import Sidebar from './Sidebar';
import useApi from 'common/hooks/useApi';
import AlertIcon from 'common/components/alert/AlertIcon';
import AlertType from 'common/types/AlertType';

type HeaderProps = {
  isAuthenticated: boolean;
  name: string;
  cartCount: number;
  onLogOut: () => void;
};

export default function Header(props: HeaderProps) {
  const { cartCount, isAuthenticated, name } = props;
  const [{ data: alertMessage }, getAlertMessage] = useApi<string>({
    url: '/messages/homePage',
    method: 'GET',
    bypassTokenCheck: true,
    responseType: 'text/plain',
  });

  useEffect(() => {
    getAlertMessage();
  }, [getAlertMessage]);

  const navContent = (
    <ul
      className={`cds-nav-primary mt-0 ${
        isAuthenticated ? 'cds-nav-primary-small-text' : ''
      }`}
    >
      <CdsHeaderNavLink to='/static-pages/faq'>FAQ</CdsHeaderNavLink>
      <CdsHeaderNavLink to='/static-pages/help'>Help</CdsHeaderNavLink>
      <CdsHeaderNavLink to='/static-pages/shuol'>
        What is an Operator&apos;s License
      </CdsHeaderNavLink>
      <CdsHeaderNavLink to='https://chicago.gov/sharedhousing' external>
        Shared Housing Website
      </CdsHeaderNavLink>
      <CdsHeaderNavLink to='/static-pages/contact'>Contact Us</CdsHeaderNavLink>
      {isAuthenticated && (
        <CdsHeaderNavLink to='/cancel-registration'>
          Request Registration Cancellation
        </CdsHeaderNavLink>
      )}
    </ul>
  );
  if (isAuthenticated) {
    return (
      <CdsHeader
        alertBanner={
          alertMessage && (
            <div className='app-message-banner' role='banner'>
              <div className='container'>
                <div className='row'>
                  <div className='col-12'>
                    <AlertIcon type={AlertType.warning} size={'inherit'} />
                    <span>{alertMessage}</span>
                  </div>
                </div>
              </div>
            </div>
          )
        }
        topRight={
          <>
            <li>Hello, {name}</li>
            <li>
              <Link id='cart-link' to='/cart'>
                <FontAwesomeIcon id='cart-icon' icon={faShoppingCart} />
                <Badge id='cart-count' variant='primary' pill>
                  {cartCount}
                </Badge>
              </Link>
            </li>
            <li>
              <Button type='button' variant='link' onClick={props.onLogOut}>
                Log Out
              </Button>
            </li>
          </>
        }
      >
        <ul className='d-md-none cds-nav-primary cds-accordion mt-0'>
          <Sidebar />
        </ul>
        <hr className='d-md-none cds-nav-menu-break' />
        {navContent}
      </CdsHeader>
    );
  }

  return (
    <CdsHeader
      alertBanner={
        alertMessage && (
          <div className='app-message-banner' role='banner'>
            <div className='container'>
              <div className='row'>
                <div className='col-12'>
                  <AlertIcon type={AlertType.warning} size={'inherit'} />
                  <span>{alertMessage}</span>
                </div>
              </div>
            </div>
          </div>
        )
      }
      topRight={
        <>
          <li>
            <Link to='/auth/login'>Log In</Link>
          </li>
        </>
      }
    >
      {navContent}
    </CdsHeader>
  );
}
